import React from 'react';
import TableCell from "@material-ui/core/TableCell";
import CustomInput from "../CustomInput/CustomInput";

const EnhancedTableCell = ({ cell, edit, classes, onEditClose }) => {
    if (cell.visible === false) return null

    let content

    if (cell.editable && edit === cell.editId) {
        content = (
            <CustomInput
                id={cell.editId}
                formControlProps={{ className: classes.textInputWrapper }}
                inputProps={{
                    placeholder: "",
                    inputProps: { className: classes.textInput },
                    onKeyPress: onEditClose,
                    onBlur: onEditClose
                }}
            />
        )
        if (cell.inputStyle || cell.inputOnClick || cell.inputClassName) {
            content = <span style={cell.inputStyle} onClick={cell.inputOnClick} className={cell.className}>
                {content}
            </span>
        }
    } else if (cell.render) {
        content = cell.render()
    } else {
        content = cell.value
    }

    const td = (
        <TableCell
            component="td"
            scope="row"
            align={cell.align}
            padding={cell.padding}
            className={cell.className}
            style={cell.style}
            onClick={cell.onClick}
        >
            {content}
        </TableCell>
    )

    if (cell.tooltip) {
        return (
            <cell.tooltip>
                {td}
            </cell.tooltip>
        )
    }

    return td
}

export default EnhancedTableCell;